export const GET_ALL_SCHEDULED_PICKUP = 'GET_ALL_SCHEDULED_PICKUP'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_ALL_SCHEDULED_PICKUP_USER_DATA =
    'GET_ALL_SCHEDULED_PICKUP_USER_DATA'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_TODAY_BOOKING = 'GET_TODAY_BOOKING'
export const GET_TODAY_WAITLIST = 'GET_TODAY_WAITLIST'
export const GET_TODAY_SERVING = 'GET_TODAY_SERVING'
export const GET_TODAY_COMPLETED = 'GET_TODAY_COMPLETED'
